<template>
      <div
      ref="receiptRoot"
      class="receipt"
      :class="receiptClass"
      >
        <div class="header">
            <div v-if='!isOrderDetail' class="type_title">
              {{ receiptName }}
            </div>
            <div class="store-name">
                {{ firstMenu?.placeName}}
            </div>
            <div></div>
            <div  :class="setPink" class="amount" >{{ addPriceUnit(ordersheet?.totalPrice) }}</div>
        </div>
        <div class="section">
            <div class="info-row">
                <span class="info-label">주문번호</span>
                <span class="info-value break-all">{{ordersheet?.orderNum}}</span>
            </div>
            <div class="info-row">
                <span class="info-label">주문상품</span>
                <span class="info-value">
                  {{ firstMenu?.name }}
                  {{ menuLength > 1 ? `외 ${menuLength -1}개` : ''}}
                </span>
            </div>
            <div class="info-row divider"></div>
            <div class="info-row">
                <span class="info-label">공급가액</span>
                <span class="info-value">
                  {{ addPriceUnit(ordersheet?.supplyAmount) }}
                </span>
            </div>
            <div class="info-row">
                <span class="info-label">부가세</span>
                <span class="info-value">{{ addPriceUnit(ordersheet?.vat) }}</span>
            </div>
            <div class="info-row">
                <span class="info-label">합계</span>
                <span class="info-value">{{ addPriceUnit(ordersheet?.totalPrice) }}</span>
            </div>
        </div>
        <div class="section">
            <div class="section-title">결제 정보</div>
            <div v-for="(pay, i) in ordersheet?.orderPayments" :key="i">
              <div v-if="i > 0" class="info-row divider"></div>
              <div class="info-row">
                <span :class="setPink" class="info-label label-highlight">{{ parsePaymentType(pay.approvalType) }}</span>
                <span :class="setPink" class="info-value label-highlight">{{ addPriceUnit(pay.amount) }}</span>
              </div>
              <template v-if="pay.approvalType">
                <div class="info-row">
                  <span class="info-label">카드사명</span>
                  <span class="info-value">{{ pay.approvalName }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">거래유형</span>
                  <span class="info-value"> {{ isCancel ? '취소' : '승인' }} </span>
                </div>
                <div class="info-row">
                  <span class="info-label">거래일시</span>
                  <span class="info-value">{{ pay.approvalDate }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">일시불/할부</span>
                  <span class="info-value">{{ parseInstallment(pay.installment) }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">승인번호</span>
                  <span class="info-value">{{ pay.approvalCode }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">가맹점 번호</span>
                  <span class="info-value"> {{ ordersheet?.storeNo }} </span>
                </div>
              </template>
              <template v-else>
                <div class="info-row">
                  <span class="info-label">거래일시</span>
                  <span class="info-value">{{ pay.approvalDate }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">승인번호</span>
                  <span class="info-value">{{ pay.approvalCode }}</span>
                </div>
              </template>
            </div>
        </div>
        <div class="section store-info">
          <div class="section-title fs-18">가맹점 정보</div>
          <div class="info-row">
              <span class="info-label">상호명 :</span>
              <span class="info-value">{{ ordersheet?.serviceInfo.companyName }}</span>
          </div>
          <div class="info-row">
              <span class="info-label">대표자명 :</span>
              <span class="info-value">{{ ordersheet?.serviceInfo.ceoName }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">사업자등록번호 :</span>
            <span class="info-value">{{ordersheet?.serviceInfo.businessNumber}}</span>
          </div>
          <div class="info-row">
              <span class="info-label">전화번호 :</span>
              <span class="info-value">{{ordersheet?.serviceInfo.phone}}</span>
          </div>
          <div class="info-row">
              <span class="info-label">주소 :</span>
              <span class="info-value">{{ordersheet?.serviceInfo.address}}</span>
          </div>
        </div>
        <div class="section seller-info">
          <div class="section-title fs-18">판매자 정보</div>
          <div class="info-row">
              <span class="info-label">상호명 :</span>
              <span class="info-value">{{ ordersheet?.storeInfo.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">대표자명 :</span>
            <span class="info-value">{{ ordersheet?.storeInfo.owner }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">사업자등록번호 :</span>
            <span class="info-value">{{ formatBizNo(ordersheet?.storeInfo?.storeGroupTb.businessNumber) }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">전화번호 :</span>
            <span class="info-value">{{ parsePhoneNumber(ordersheet?.storeInfo.phone) }}</span>
          </div>
          <div class="info-row">
              <span class="info-label">주소 :</span>
              <span class="info-value">{{ ordersheet?.storeInfo.address }}</span>
          </div>
        </div>
        <div v-if="isOrderDetail" class="buttons">
            <button @click="saveAsImage" class="btn">저장하기</button>
            <button @click="sendEmail" class="btn btn-primary">이메일로 발송하기</button>
        </div>
    </div>
</template>
<script>
import service from '@/backend/modnpay_app_api'
import { ORDER_BILL_SEND_NAME } from '@/utils/EndPoint'
export default ({
  props: {
    isOrderDetail: {
      type: Boolean,
      required: false,
      default: true
    },
    receiptClass: {
      type: String,
      required: false,
      default: 'receipt--detail'
    }
  },
  data () {
    return {
      ordersheet: null,
      menus: []
    }
  },
  computed: {
    prevOrderHistory () { return this.$store.getters.prevOrderHistory },
    firstMenu () {
      return this.ordersheet?.menus[0] ? this.ordersheet?.menus[0] : null
    },
    menuLength () {
      return this.ordersheet?.menus.length
    },
    isCancel () {
      return this.ordersheet?.orderProgressFlag === 4
    },
    setPink () {
      return this.isCancel ? 'pink' : ''
    },
    receiptName () {
      return this.isCancel ? '취소 영수증' : '영수증'
    }
  },
  created () {
    const orderSeq = this.$store.getters.orderSeq
    const storeGroupCode = this.$store.getters.storeGroupCode
    const req = {
      cmd: 'pos.order.order.sheet.req.json',
      storeInfoYN: 'Y',
      orderSeq,
      storeGroupCode

    }
    this.initOrdersheet(req)
  },
  methods: {
    async initOrdersheet (req) {
      const { data } = await service.selectOrderSheet(req)
      this.ordersheet = data.ordersheet
      const payments = this.ordersheet.orderPayments
      // 카드 결제 먼저 나오도록 정렬
      payments.sort((a, b) => {
        if (a.approvalType === null && b.approvalType !== null) return 1
        if (a.approvalType !== null && b.approvalType === null) return -1
        return 0
      })
      // 웹 영수증 상세보기인 경우 영수증 이름 전달
      if (this.isOrderDetail) {
        this.$emit('setReceiptName', this.receiptName)
      }
    },
    addPriceUnit (price) {
      const minusSign = this.isCancel ? '-' : ''
      const priceFormat = price ? `${Number(price).toLocaleString()} 원` : '- 원'
      return minusSign + priceFormat
    },
    parsePaymentType (approvalType) {
      return approvalType ? '카드' : '온누리상품권'
    },
    parseInstallment (installment) {
      return installment || installment > 1 ? `${installment} 개월` : '일시불'
    },
    sendEmail () {
      this.$router.push({
        name: ORDER_BILL_SEND_NAME
      })
    },
    formatBizNo (bizNo) {
      // 문자열로 변환 후 숫자만 남기기
      const digits = String(bizNo).replace(/\D/g, '')

      return `${digits.substring(0, 3)}-${digits.substring(3, 5)}-${digits.substring(5)}`
    },
    saveAsImage () {
      this.$emit('saveAsImage')
    }
  }

})
</script>
<style scoped>
:root,
body {
    font-size: 10px !important;
    line-height: 1;
}

#header{
    height: 5.6rem;
}

html{
    height: auto;
}

@media (max-width: 359.8px) {

    :root,
    body {
        font-size: 8.75px !important;
    }
}

@media (min-width: 436px) {
    body {
        background-color: #f6f6f6;
        width: 100%;
    }
}
@media (min-width: 808px) {
    #app {
        background-color: transparent
    }
}
</style>
<style lang="scss" scoped>

.receipt.receipt--email {
    border: 1px solid #00000026;
    padding-top: 3rem;
    padding-bottom: 0rem;
    padding: 1.6rem 3rem;
    margin-top: 1rem;
    max-width: 38.75rem;
}

.receipt.receipt--detail {
  padding: 1.6rem;
  padding-top: 7.2rem;
}
.receipt {
    margin: 0 auto;
    background: white;

    .header {
        text-align: center;
        margin-bottom: 1.6rem;
    }

    .store-name {
        font-size: 2rem;
        color: #0d0d0d;
        text-align: left;
        font-weight: bold;
        margin-bottom: 1.6rem;
        line-height: 1.5;
    }

    .amount {
        font-size: 2.8rem;
        font-weight: bold;
        color: var(--primary);
        padding-bottom: 2.4rem;
        border-bottom: 1px solid #0d0d0d;
        height: 100%;
        text-align: left;
    }
    .pink{
      color: #f119a9;
    }

    .section {
        margin-bottom: 3.2rem;
        padding-bottom: 3.2rem;
        border-bottom: 1px solid #0d0d0d;

        &.seller-info {
            border: none;
            margin-bottom: 0;
        }

        .section-title {
            font-weight: bold;
            color: #333;
            padding-top: 0;
            text-align: left;
            font-size: 1.6rem;
        }

        .info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.8rem;
            min-height: 2.4rem;
            gap: 0.8rem;

            &.divider {
                border-bottom: 1px dotted #707070;
                padding-top: 0.8rem;
                margin-bottom: 1.6rem;
                min-height: 0;
                opacity: 0.4;
            }

            .info-label {
                color: #666;
                font-size: 1.6rem;
            }

            .info-value {
                color: #333;
                font-size: 1.6rem;
                font-weight: 500;
                text-align: right;
                word-break: keep-all
            }
            .pink{
              color: #f119a9;
            }

            &:last-of-type {
                margin-bottom: 0;
            }
        }

        &.store-info,
        &.seller-info {
            text-align: left;

            .section-title{
                padding-bottom: 1.6rem;
            }

            .info-row {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                margin-bottom: 0.8rem;
                min-height: 2rem;
                gap: 0;

                .info-label {
                    font-weight: 500;
                    min-width: 4rem;
                    font-size: 1.4rem;
                }

                .info-value {
                    color: #666;
                    font-weight: normal;
                    margin-left: 0.4rem;
                    font-size: 1.4rem;
                    text-align: left;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .buttons {
        display: flex;
        gap: 1rem;
        margin-top: 0;

        .btn {
            flex: 1;
            padding: 1rem 1.6rem;
            border: 1px solid #ddd;
            background: white;
            cursor: pointer;
            font-size: 1.5rem;
            transition: all 0.2s;
            &.btn-primary {
                color: #0d0d0d;
                border: 1px solid #ddd;
            }
        }
    }
}

.label-highlight {
    color: var(--primary) important;
    font-size: 1.6rem !important;
    font-weight: bold !important;
}

.break-all{
    word-break: break-all !important;
}

.fs-18 {
    font-size: 1.8rem !important;
}
.type_title{
    font-size: 2rem;
    color: #0d0d0d;
    text-align: left;
    font-weight: bold;
    margin-bottom: 2.2rem;
    line-height: 1.5;
    border-bottom: 1px dotted #dddddd;
    text-align: center;
    padding-bottom: 2.2rem;

}
</style>
